import { Button, Tag } from 'antd';
import React from 'react';

import { SDetailLayout } from 'app/components/StaycationUI';
import type { Mode } from 'app/components/commons/Hotel/Types';

type BookingDetailsHeaderProps = {
  title: string;
  mode: Mode;
  isLoading: boolean;
  buttonSaveText?: string;
  onEditEmail: () => void;
  children: React.ReactNode;
};

export const BookingDetailsHeader = ({
  mode,
  isLoading,
  title,
  buttonSaveText,
  onEditEmail,
  children,
}: BookingDetailsHeaderProps) => {
  return (
    <SDetailLayout
      title={
        <>
          {title} <Tag color="#87d068">New data model</Tag>
        </>
      }
      mode={mode}
      buttonSaveText={buttonSaveText}
      headerExtra={<Button onClick={onEditEmail}>Edit</Button>}
      isDirty
      backRoute="/bookings"
      isLoading={isLoading}
      hasFooter={false}
    >
      {children}
    </SDetailLayout>
  );
};
